function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Icon"
}, /*#__PURE__*/React.createElement("title", null, "HD_Icons_Ivonne_Final"), /*#__PURE__*/React.createElement("path", {
  d: "M201.4 184.5l28.8-28.8H156v-28h74.1L201.4 99l19.8-19.6 62.3 62.3-62.3 62.3-19.8-19.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v283.5h184v-99h-28.1v70.6H28.3V28.3h127.6v71.2H184V0z"
}))));